<div class="form-check form-switch d-flex align-items-center spacing-12">
  <input
    aria-label="toggle"
    class="cursor-pointer form-check-input size-{{ size }}"
    type="checkbox"
    role="switch"
    [id]="'switch-' + id"
    [attr.name]="name"
    [checked]="active"
    [disabled]="disabled"
    (change)="toggleActive()"
    (blur)="onTouched?.()" />
  <label class="form-check-label" [for]="'switch-' + id"
    ><span class="h4-bold primary-100 d-flex align-items-center spacing-4"
      >{{ toggleLabel }}
      <app-ce-icon
        *ngIf="help"
        class="primary-50"
        [name]="'help'"
        [svg_class]="['d-flex']"
        [matTooltip]="info"
        [matTooltipPosition]="'right'"
        placement="right"
        container="body"></app-ce-icon></span
  ></label>
</div>
